// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { OwnerPlannerFragment } from '../../fragments/generated/owner-planner.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetOwnerPlannerQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOwnerPlannerQueryResult = { __typename?: 'Query', getOwnerPlanner: { __typename?: 'OwnerPlannerDTO', id: number, ownerId: number, visibilityDays: number | null, roomOrderOnPlanner: number | null, showAvailableRooms: boolean, showStay: boolean, showRoomPreparation: boolean, showHousekeepingStatus: boolean, showDamages: boolean, hoursOperatorMandatory: boolean, openHour: number | null, closeHour: number | null, calendarRed: number | null, calendarGreen: number | null, calendarBlue: number | null, firstColumnRed: number | null, firstColumnGreen: number | null, firstColumnBlue: number | null, saturdayRed: number | null, saturdayGreen: number | null, saturdayBlue: number | null, sundayRed: number | null, sundayGreen: number | null, sundayBlue: number | null, todayRed: number | null, todayGreen: number | null, todayBlue: number | null, saturdayHeaderRed: number | null, saturdayHeaderGreen: number | null, saturdayHeaderBlue: number | null, sundayHeaderRed: number | null, sundayHeaderGreen: number | null, sundayHeaderBlue: number | null, todayHeaderRed: number | null, todayHeaderGreen: number | null, todayHeaderBlue: number | null, defaultReservationRed: number | null, defaultReservationGreen: number | null, defaultReservationBlue: number | null, checkInReservationRed: number | null, checkInReservationGreen: number | null, checkInReservationBlue: number | null, arrivingReservationRed: number | null, arrivingReservationGreen: number | null, arrivingReservationBlue: number | null, borderIfRoomChange: boolean, boldIfDifferentStay: boolean } | null };

export const GetOwnerPlannerGql = gql`
    query GetOwnerPlanner {
  getOwnerPlanner {
    ...OwnerPlanner
  }
}
    ${OwnerPlannerFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOwnerPlannerInjectable extends Apollo.Query<GetOwnerPlannerQueryResult, GetOwnerPlannerQueryVariables> {
    override document = GetOwnerPlannerGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */